{
  "version": 1,
  "asset_id": "ed79b33d-3201-4208-ad67-7f1a1eb8084d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/ed79b33d-3201-4208-ad67-7f1a1eb8084d/wordmark-600.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/ed79b33d-3201-4208-ad67-7f1a1eb8084d/wordmark-600.avif",
  "original_filename": "wordmark-600.avif",
  "size": 11446,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:19:14Z"
}
